if (typeof MapaCirculos !== " function") {
  window.MapaCirculos = function (wrapper, duracion, municipios) {
    let box = new Box({
      size: { width: 620, height: 400 },
      padding: 20,
    });

    let projection = d3.geoMercator();
    let path = d3.geoPath();

    let svg = null;
    let gMapa = null;
    let gMunicipios = null;
    let gCirculos = null;
    let gLeyenda = null;

    let svgLeyenda = null;
    let gEtiquetas = null;

    const color = d3.scaleSymlog().range(["#ff8585", "#ff0000"]);
    const radio = d3.scaleSqrt().range([2, 10]);

    function setup() {
      crearSVG(wrapper);
      procesarDatos();
      crearMapa();
      crearLeyenda();
    }

    function crearSVG(wrapper) {
      svg = wrapper
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr("viewBox", `0 0 ${box.width} ${box.height}`);

      svg = svg.append("g");

      svg = svg
        .append("g")
        .attr(
          "transform",
          `translate(${box.padding.left}, ${box.padding.top})`,
        );

      gMapa = svg.append("g");

      gMunicipios = gMapa
        .append("g")
        .style("stroke", "#b8b8b8ff")
        .style("stroke-width", 0.2)
        .style("fill", "transparent")
        .attr("data-g", "gMunicipios");

      gCirculos = gMapa
        .append("g")
        .style("stroke-width", 1)
        .style("fill", "#ff0000")
        .attr("data-g", "gCirculos");

      gLeyenda = gMapa.append("g").attr("data-g", "gLeyenda");
    }

    function procesarDatos() {
      _.each(municipios.objects.municipios.geometries, function (d) {
        d.properties.tasa_contagios =
          d.properties.contagios == null
            ? 0
            : (d.properties.contagios * 100000) / d.properties.poblacion;
      });

      let arreglo = _.map(
        municipios.objects.municipios.geometries,
        (d) => d.properties.tasa_contagios,
      );
      arreglo = _.filter(arreglo, (d) => d != null);
      color.domain([0, d3.max(arreglo)]);
      radio.domain([0, d3.max(arreglo)]);
    }

    function crearMapa() {
      municipios = topojson.feature(municipios, municipios.objects.municipios);
      municipios = municipios.features;

      let obj = {
        type: "FeatureCollection",
        features: municipios,
      };

      projection.fitSize([box.content.width, box.content.height], obj);
      path.projection(projection);

      gMunicipios
        .selectAll("path")
        .data(municipios)
        .enter()
        .append("path")
        .attr("d", path)
        .on("mouseover", crearTooltip)
        .on("mouseout", deshacerTooltip);

      gCirculos
        .selectAll("circle")
        .data(municipios)
        .enter()
        .filter((d) => d.properties.tasa_contagios != 0)
        .append("circle")
        .each(function (d) {
          [d.properties.x, d.properties.y] = path.centroid(d);
        })
        .style("opacity", 0.5)
        .style("pointer-events", "none")
        .attr("cx", (d) => d.properties.x)
        .attr("cy", (d) => d.properties.y)
        .attr("r", (d) => radio(d.properties.tasa_contagios));
    }

    function crearLeyenda() {
      gLeyenda
        .attr("transform", "translate(20,340)")
        .style("stroke-width", 0.5);

      let arreglo = [0, 10, 50, 100, 500, 1000];
      let l = 0;
      let x = 0;

      let etiqueta = gLeyenda.append("text");

      _.each(arreglo, function (d) {
        l = radio(d);
        gLeyenda
          .append("circle")
          .attr("r", radio(d))
          .attr("cx", x + l)
          .attr("cy", 6)
          .style("fill", "#ff0000")
          .style("stroke", "#b8b8b8");

        gLeyenda
          .append("text")
          .text(d)
          .attr("x", x + l)
          .attr("y", -6)
          .style("font-size", "9px")
          .attr("text-anchor", "middle");

        x += 2 * l + 10;
      });

      let rect = gLeyenda.node().getBBox();

      etiqueta
        .text("Contagios por cien mil habitantes")
        .attr("x", rect.width / 2)
        .attr("y", -20)
        .style("font-size", "12px")
        .attr("text-anchor", "middle");
    }

    function crearTooltip(e, d) {
      if (d.properties.contagios != null) {
        let entidad =
          d.properties.NOM_ENT == "México"
            ? "Estado de México"
            : d.properties.NOM_ENT;
        let [x, y] = d3.pointer(e, this);
        let el = d3.select(this);
        let cajaPath = el.node().getBBox();
        y = cajaPath.y;

        let gTooltip = gMapa.append("g").attr("class", "tooltip ignore");

        let rect = gTooltip
          .append("rect")
          .attr("x", 0)
          .attr("y", 0)
          .attr("width", 0)
          .attr("height", 0)
          .style("fill", "#ffffff")
          .style("stroke", "gray")
          .style("stroke-width", "0.5px");

        let text = gTooltip
          .append("text")
          .attr("x", 0)
          .attr("y", 0)
          .attr("dy", 0)
          .attr("text-anchor", "middle")
          .style("font-size", "10px");

        text
          .append("tspan")
          .style("font-weight", 700)
          .text(`${d.properties.NOM_MUN}, ${entidad}`);

        text
          .append("tspan")
          .attr("x", 0)
          .attr("y", 14)
          .style("font-weight", 700)
          .text(`${d.properties.tasa_contagios.toFixed(2)}`);
        text.append("tspan").text(` contagios por cada 100,000 habitantes`);

        let caja = text.node().getBBox();

        y -= caja.height - 5;
        y = y <= 0 ? 20 : y;

        rect
          .attr("x", caja.x - 2.5)
          .attr("y", caja.y - 2.5)
          .attr("width", caja.width + 5)
          .attr("height", caja.height + 5);

        let overflow = x + (caja.x - 2.5) + (caja.width + 5);
        let underflow = x - (caja.x - 2.5 + (caja.width + 5));
        let width = caja.width + 5;

        if (overflow > box.content.width) {
          gTooltip.attr(
            "transform",
            `translate(${box.content.width - width / 2}, ${y})`,
          );
        } else if (underflow < 0) {
          gTooltip.attr("transform", `translate(${0 + width / 2}, ${y})`);
        } else {
          gTooltip.attr("transform", `translate(${x}, ${y})`);
        }
      }
    }

    function deshacerTooltip(e, d) {
      gMapa.selectAll("g.tooltip").remove();
    }

    setup();
  };
}
